type ErrorData = Partial<{
  error: string;
  errors: string[] | Record<string, string>;
}>;

export class ResponseError extends Error {
  protected _data: ErrorData;

  public get data(): ErrorData {
    return this._data;
  }

  constructor(message: string, data: ErrorData) {
    super(message);

    this._data = data;
  }
}
